"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var StyledMain = (0, _material.styled)("main")(function () {
  return {
    flexGrow: 1,
    overflowY: "scroll"
  };
});

var MainContent = function MainContent(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMain, {
    children: props.children
  });
};

var _default = MainContent;
exports.default = _default;